import { render, staticRenderFns } from "./highlight-button-icons.vue?vue&type=template&id=0081304f&scoped=true"
import script from "./highlight-button-icons.vue?vue&type=script&lang=js"
export * from "./highlight-button-icons.vue?vue&type=script&lang=js"
import style0 from "./highlight-button-icons.vue?vue&type=style&index=0&id=0081304f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081304f",
  null
  
)

export default component.exports